import { isNull } from 'lodash/fp';
import React, { useMemo, useState } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../hooks/react-redux';
import { ClientFeaturePermission, FeaturePermission } from '../../../admin/users/store';
import { getClientHasFeaturePermission, getMyProfile, getUserHasFeaturePermission } from '../../../auth/login/store';
import { UserRole } from '../../../constants/permittedRoles';
import { UploadModal } from '../../../shared/modal/UploadModal';
import { getFilesToUpload, getIsUploading, getUploadModalOpen, setInitialUploadDocuments, toggleUploadModal, uploadDocumentStarted } from '../store';

const inAnalysis = false;

export const UploadDocumentsModal: React.FC = () => {
    const hasDocumentExtractAIPermission = useAppSelector(getClientHasFeaturePermission([ClientFeaturePermission.DOCUMENT_EXTRACT_WITH_AI]));
    const [completeWithAI, setCompleteWithAI] = useState(hasDocumentExtractAIPermission);
    const [analyseLater, setAnalyseLater] = useState(false);

    const dispatch = useAppDispatch();

    const uploadModalOpen = useAppSelector(getUploadModalOpen);
    const isUploading = useAppSelector(getIsUploading);
    const files = useAppSelector(getFilesToUpload);
    const user = useAppSelector(getMyProfile);

    const setDocumentsForUpload = (files: File[]) => dispatch(setInitialUploadDocuments(files));
    const closeModal = () => dispatch(toggleUploadModal(false));
    const hasUploadDocumentPermission = useAppSelector(getUserHasFeaturePermission([FeaturePermission.UPLOAD_DOCUMENTS]));
    const uploadDocument = () => hasUploadDocumentPermission && dispatch(uploadDocumentStarted(inAnalysis, completeWithAI, analyseLater));
    const userClientHasAccessGroups = useMemo(() => !isNull(user) && user.clientHasAccessGroups === 1, [user]);
    const userIsInGroup = useMemo(() => !isNull(user) && !isNull(user.accessGroupIds) && user.accessGroupIds.length > 0, [user]);
    const needsCounterpartyPermission = useMemo(() => userClientHasAccessGroups && !userIsInGroup && !isNull(user) && user.role !== UserRole.SYSTEM_ADMIN, [userClientHasAccessGroups, userIsInGroup, user]);

    return (
        <UploadModal
            isOpen={uploadModalOpen}
            setUploadDocuments={setDocumentsForUpload}
            modalLabel='Upload New Document(s)'
            testId='upload-document-modal'
            closeModal={closeModal}
            isUploading={isUploading}
            files={files}
            uploadDocument={uploadDocument}
            completeWithAI={completeWithAI}
            setCompleteWithAI={setCompleteWithAI}
            showCompleteWithAIOption={hasDocumentExtractAIPermission}
            canUpload={hasUploadDocumentPermission}
            showAnalyseLaterOption
            analyseLater={analyseLater}
            setAnalyseLater={setAnalyseLater}
            needsCounterpartyPermission={needsCounterpartyPermission}
        />
    );
};
